// extracted by mini-css-extract-plugin
export default {"card":"Card_card__C3a+7","title":"Card_title__992pa","content":"Card_content__bHE+m"};